let formatTime = function (value) {
  if (!value) {
    return
  }
  let newValue = value * 1000
  newValue = new Date(newValue)
  let hours = newValue.getHours()
  let minutes = newValue.getMinutes()
  if (minutes < 10) {
    minutes = '0' + minutes
  }
  if (hours < 10) {
    hours = '0' + hours
  }
  return hours + ':' + minutes
}

export default formatTime
